export default {

    indexSpecificities: { method: 'get',    url: 'specificities' },
    storeSpecificity:   { method: 'post',   url: 'specificities' },
    updateSpecificity:  { method: 'put',    url: 'specificities/{id}'},
    destroySpecificity: { method: 'delete', url: 'specificities/{id}'},

}